import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays a Klarna instalments message.
 * It listens for variant update events and swaps in the freshly rendered
 * per-instalment amount so the price stays in sync with the selected variant.
 */
class KlarnaMessage extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.updateAmount);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateAmount);
  }

  updateAmount = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const fresh = html.querySelector(`klarna-message[data-block-id="${this.dataset.blockId}"]`);
    if (!fresh) return;

    const newAmount = fresh.querySelector('[data-klarna-amount]');
    const currentAmount = this.querySelector('[data-klarna-amount]');
    if (newAmount && currentAmount) {
      currentAmount.replaceWith(newAmount);
    }
  };
}

if (!customElements.get('klarna-message')) {
  customElements.define('klarna-message', KlarnaMessage);
}
